import React, { Component } from 'react';
import { IconButton, Slide } from '@material-ui/core';
import autoBind from 'auto-bind';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import PropTypes from 'prop-types';
import './carousel.scss';
// import { appNavigationInfo } from "../../redux/reducers/appNavigation";

export default class Carousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            isSwipeLeft: true
        };
        this.timer = null;
        this.previousTouch = null;
        autoBind(this);
    }

    componentDidMount() {
        this.start();

        let touchsurface = document.getElementById(this.props.id);
        if (touchsurface) {
            touchsurface.addEventListener('touchstart', (e) => {
                let touchobj = e.changedTouches[0]
                this.dist = 0
                this.startX = touchobj.pageX
                e.preventDefault()
            }, false)

            touchsurface.addEventListener('touchmove', (e) => {
                e.preventDefault() // prevent scrolling when inside DIV
            }, false)

            touchsurface.addEventListener('touchend', (e) => {
                let touchobj = e.changedTouches[0]
                this.dist = touchobj.pageX - this.startX // get total dist traveled by finger while in contact with surface
                if (Math.abs(this.dist) > 100 && this.dist > 0) {
                    this.shouldProceedTouch(e, this.prev)
                } else if (Math.abs(this.dist) > 100 && this.dist < 0) {
                    this.shouldProceedTouch(e, this.next)
                } else if (Math.abs(this.dist) < 5) {
                    touchobj.target.click()
                }
                e.preventDefault()
            }, false)
        }
    }

    componentWillUnmount() {
        this.stop();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.active !== this.props.active) {
            this.setState({active: 0})
            if (this.props.onSlideChange) this.props.onSlideChange(0)
        }
        if (prevProps.autoPlay !== this.props.autoPlay || prevProps.interval !== this.props.interval) {
            this.reset();
        }
        if (this.props.autoPlay) {
            if (prevProps.active !== this.props.active) {
                if (this.props.active) {
                    this.reset();
                } else {
                    this.stop();
                }
            }
            if (this.props.isPaused === true) {
                this.stop();
            } else if (prevProps.isPaused !== this.props.isPaused && this.props.isPaused !== true ) {
                this.reset();
            }
        }
    }

    stop() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    start() {
        if (this.props.autoPlay) {
            this.timer = setInterval(this.next, this.props.interval);
        }
    }

    reset() {
        this.stop();

        if (this.props.autoPlay) {
            this.start();
        }
    }

    pressIndicator(index) {
        if (index > this.state.active) {
            this.setState(
                {
                    active: index,
                    isSwipeLeft: true
                },
                this.reset,
            );
        } else {
            this.setState(
                {
                    active: index,
                    isSwipeLeft: false
                },
                this.reset,
            );
        }
    }

    shouldProceedTouch(event, cb) {
        let now = Date.now();
        if (now - this.previousTouch > 800) {
            cb(event)
            this.previousTouch = now
        }
    }

    next(event) {
        const nextActive = this.state.active + 1;
        const next = nextActive > this.props.children.length - 1 ? 0 : nextActive;

        if (!this.props.isPaused || !!event) {
            this.setState(
                {
                    active: next,
                    isSwipeLeft: true
                },
                this.reset,
            );

            if (this.props.onSlideChange) {
                this.props.onSlideChange(next)
            };
        }

        if (event)
            event.stopPropagation();
    }

    prev(event) {
        const prevActive = this.state.active - 1;
        const prev = prevActive < 0 ? this.props.children.length - 1 : prevActive;

        this.setState(
            {
                active: prev,
                isSwipeLeft: false
            },
            this.reset,
        );

        if (this.props.onSlideChange) {
            this.props.onSlideChange(prev)
        }

        if (event)
            event.stopPropagation();
    }

    render() {
        const { animation } = this.props;

        return (
            <div
                className={`Carousel ${this.props.className ? this.props.className : ''}`}
            >
                <div id={this.props.id}>
                    {Array.isArray(this.props.children) ? (
                        this.props.children.map((child, index) => (
                            <CarouselItem key={"carouse-item" + index} active={index === this.state.active}
                                          child={child} animation={animation} isSwipeLeft={this.state.isSwipeLeft}/>
                        ))
                    ) : (
                        <CarouselItem key={0} active child={this.props.children} isSwipeLeft={this.state.isSwipeLeft}/>
                    )}
                </div>

                <div className={`Next ButtonWrapper ${this.props.disabledMode ? "isDisableMode" : ""}`}>
                    <IconButton className="Next Button mui--align-middle" onClick={event => this.shouldProceedTouch(event, this.next)}>
                        <img
                            src={this.props.nextIcon ? this.props.nextIcon : require("../../assets/images/carousel/next.png")}
                            alt=""/>
                    </IconButton>
                </div>

                <div className={`Prev ButtonWrapper ${this.props.disabledMode ? "isDisableMode" : ""}`}>
                    <IconButton className="Prev Button mui--align-middle" onClick={event => this.shouldProceedTouch(event, this.prev)}>
                        <img
                            src={this.props.backIcon ? this.props.backIcon : require("../../assets/images/carousel/back.png")}
                            alt=""/>
                    </IconButton>
                </div>

                {this.props.isShowIndicators ? (
                    <Indicators length={this.props.children.length} active={this.state.active}
                                press={this.pressIndicator}/>
                ) : null}
            </div>
        );
    }
}

Carousel.propTypes = {
    children: PropTypes.array,
    className: PropTypes.string,
    autoPlay: PropTypes.bool,
    interval: PropTypes.number,
    animation: PropTypes.string,
    // orientation: PropTypes.string,
    disabledMode: PropTypes.bool,
    active: PropTypes.bool
};

Carousel.defaultProps = {
    active: true,
    autoPlay: true,
    interval: 8000,
    animation: 'fade',
    disabledMode: false,
    // orientation: appNavigationInfo.orientation.portrait
};

function CarouselItem(props) {
    let direction
    if (props.isSwipeLeft) {
        if (props.active) {
            direction = "left"
        } else {
            direction = "right"
        }
    } else {
        if (props.active) {
            direction = "right"
        } else {
            direction = "left"
        }
    }
    return (
        <div className={`CarouselItem ${props.active ? 'active' : ''}`}>
            <Slide direction={direction} in={props.active} timeout={{ enter: 400, exit: 500, appear: 500 }}>
                <div>{props.child}</div>
            </Slide>
        </div>
    );
}

CarouselItem.propTypes = {
    active: PropTypes.bool,
    child: PropTypes.object,
    animation: PropTypes.string,
};

function Indicators(props) {
    const indicators = [];
    for (let i = 0; i < props.length; i += 1) {
        const className = i === props.active ? 'Active Indicator' : 'Indicator';
        const item = (
            <FiberManualRecordIcon
                key={i}
                size="small"
                className={className}
                onClick={() => {
                    props.press(i);
                }}
            />
        );

        indicators.push(item);
    }

    Indicators.propTypes = {
        press: PropTypes.func,
        length: PropTypes.number,
        active: PropTypes.number,
    };

    return <div className="Indicators">{indicators}</div>;
}
